import React from 'react'

import { SimpleArticle } from "/react4xp/parts/simple-article/simple-article"

export default (props) => <SimpleArticle {...props} />
